import Button from './Button.jsx';

/** A small "?" that opens the guide right at the topic for the current screen. */
export default function HelpButton({ topic, label = 'Help' }) {
  return (
    <Button iconOnly icon="help" to={`/guide${topic ? `#${topic}` : ''}`} title="How this works">
      {label}
    </Button>
  );
}
